module.exports = __webpack_public_path__ + "media/O Level Mobile Gif.8e68b75f.mp4";